import { useQuery } from '@tanstack/react-query';

import getAvailableBriefDates from 'Api/brief-live/getAvailableBriefDates';

import getAvailableBriefDatesRequest from './model/request/getAvailableBriefDatesRequest';
import getAvailableBriefDatesResponse from './model/response/getAvailableBriefDatesResponse';

const useGetAvailableBriefDates = (queryParams) => {
  return useQuery({
    queryKey: ['available-brief-dates', queryParams],
    queryFn: async () => {
      const queries = getAvailableBriefDatesRequest(queryParams);

      const response = await getAvailableBriefDates(queries);

      return getAvailableBriefDatesResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!queryParams?.brandId,
  });
};

export default useGetAvailableBriefDates;
